import Vue from 'vue'
import Router from 'vue-router'
import Signin from '@/components/Signin'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        name: 'Signin',
        component: Signin
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard
    },
  ]
})